import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "arrayUnique",
    standalone: false
})
export class ArrayUniquePipe implements PipeTransform {
  transform<T>(items: T[], key: string, subkey?: string): T[] {
    if (!items || !key) return [];

    const checkedValues: any[] = [];
    return items.filter((it) => {
      // @ts-ignore
      const compare = subkey ? it[key]?.[subkey] : it[key];
      if (compare && !checkedValues.includes(compare)) {
        checkedValues.push(compare);
        return true;
      }
      return false;
    });
  }
}
